import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  deleteDialog: {
    width: "30%"
  }
}));

export default styles;
